let config = {};

export const setConfig = (newConfig = {}) => {
  config = newConfig;
};

export const getConfig = () => config;



// WEBPACK FOOTER //
// ./app/services/config.js